import React, { useMemo } from 'react';
import { defineMessages, useIntl } from 'react-intl-next';
import GenerativeIndicatorIcon from '@atlaskit/icon-lab/core/generative-indicator';
import { useUIStore } from '@atlassian/conversation-assistant-store';
import { type ConversationAction, HandleActionType } from '@atlassian/rovo-conversation-actions';

const messages = defineMessages({
	insightsNudgeTitle: {
		id: 'page-rovo-config-common.insights-nudge-title',
		defaultMessage: 'Explore your weekly insights',
		description: 'Title for the Rovo Insights weekly nudge that appears next to the Rovo button',
	},
	insightsNudgeIconLabel: {
		id: 'page-rovo-config-common.insights-nudge-icon-label',
		defaultMessage: 'Insights icon',
		description: 'Accessible label for the icon in the Rovo Insights weekly nudge',
	},
});

/**
 * Hook that creates and returns the Insights weekly nudge action.
 */
export function useInsightsNudgeAction(): ConversationAction {
	const { setActiveMenu } = useUIStore();
	const { formatMessage } = useIntl();

	return useMemo(
		() => ({
			id: 'rovo-insights-nudge',
			title: formatMessage(messages.insightsNudgeTitle),
			icon: () => (
				<GenerativeIndicatorIcon
					size="small"
					label={formatMessage(messages.insightsNudgeIconLabel)}
				/>
			),
			onClick: () => setActiveMenu('pulse'),
			type: 'ai-action',
			handleType: HandleActionType.Base,
			nudgeContext: {
				id: 'rovo-insights',
			},
		}),
		[setActiveMenu, formatMessage],
	);
}
